<h4 class="secondary-text" style="text-align: left; margin: 0 0 12px -10px">
    <button mat-icon-button
            color="primary"
            title="Back to sign in page"
            (click)="onBackToCredentialsLogIn()"
    >
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
    </button>
    Back to sign in page
</h4>

<div class="title" style="text-align: left">
    Enter code
</div>

<form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onFormSubmit(loginForm.value)" novalidate>

    <h3>1-time token has been sent via SMS to phone number {{phoneNumber}}.</h3>

    <mat-form-field>
        <input matInput
               placeholder="Code"
               formControlName="verificationCode"
               name="verificationCode"
               ngcAutofocus
        >
        <mat-error *ngIf="loginFormErrors?.verificationCode?.required && loginForm.controls.verificationCode.dirty">
            Code is required
        </mat-error>
    </mat-form-field>

    <button mat-raised-button color="accent"
            class="submit-button"
            aria-label="Sign in"
            [disabled]="loginForm?.invalid || (loading$ | async)"
    >
        Confirm
    </button>
</form>

<button mat-button color="accent"
        class="submit-button"
        aria-label="Resend code"
        title="Resend code"
        (click)="onSendCodeAgain()"
        [disabled]="(loading$ | async) || !!disableResendCodeBtnTimer"
>
    Resend Code {{disableResendCodeBtnTimer ? '(' + disableResendCodeBtnTimer + ')' : '' }}
</button>

<div class="recovery-code-info">
    <h4 class="mb-4">Having problems?</h4>
    <a (click)="onTurnOnRecoveryCodeLoginView()">Enter a multi-factor recovery code</a>
</div>
